import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root'
})
export class LocationHierarchyService {
  environment = EnvironmentService.environment;

  locationHierarchyMinimumLevel: number = 2;
  locationHierarchyMaximumLevel: number = 10;
  locationHierarchyMetadataList: any = [];
  locationHierarchyNodeMetadataList: any = [];

  constructor(private http: HttpClient) { }

  getLocationNodeLabel(level: any) {
    return _.get(_.find(this.locationHierarchyNodeMetadataList, (a: any) => a.locationHierarchyNodeLevel === level), 'locationHierarchyNodeName');
  }

  getLocationHierarchyLabel(level: any) {
    return _.get(_.find(this.locationHierarchyMetadataList, (a: any) => a.locationHierarchyLevel === level), 'locationHierarchyName');
  }


  GetLocationHierarchyListMetaDataList(): Observable<any> {
    return this.http.get<any>(`${this.environment.HierarchyManager}/locationHierarchyMetadataGetList`,)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetLocationHierarchyListNodeMetadataList(): Observable<any> {
    return this.http.get<any>(`${this.environment.HierarchyManager}/locationHierarchyNodeMetadataGetList`,)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  UpdateLocationHierarchyList(body: any): Observable<any> {
    return this.http.post<any>(`${this.environment.HierarchyManager}/locationHierarchyInsertOrUpdateMetadataItems`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }
}
